import { format } from "date-fns";
import api from "../services/api";

interface IAgentResponse {
    codeResult: string;
    data: any[];
}

export interface IAgentParams {
    year: string;
    month: string;
    regionalId: string;
    sectorId: string;

}
export interface IAgentMonth {
    representante: string;
    dataCad: string;
    emAberto: number;
    emAbertoAcerto: number;
    cadastros: number;
    faturamento: number;
    debitos: number;
    conferencias: number;
}


class AgentHistoryRepository {
    public async AgentMonth({ year, month, regionalId, sectorId }: IAgentParams): Promise<IAgentMonth[]> {
        const initialDate = format(new Date(parseInt(year), parseInt(month) - 1, 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
        const endDate = format(new Date(parseInt(year), parseInt(month), 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");

        const body = {
            "tables": ["Kit", "Pedido", "Representante", "Conference", "GerenteSetor", "GerenteRegional"],
            "sql": [
                {
                    "coderesult": "DadosRp",
                    "query": `SELECT Representante.id as IdRep, 
                    Representante.nome as Nome, 
                    Representante.data as Data 
                    FROM Representante 
                    INNER JOIN GerenteSetor 
                    ON GerenteSetor.id = Representante.gerenteSetorId 
                    WHERE Representante.status = 1 
                    ${sectorId.length > 0 ? `AND Representante.gerenteSetorId = '${sectorId}' ` : ""}
                    ${regionalId.length > 0 ? `AND GerenteSetor.gerenteRegionalId = '${regionalId}' ` : ""}                    
                    GROUP BY Representante.id, Representante.nome, Representante.data`
                },
                {
                    "coderesult": "EmAberto",
                    "query": `SELECT Pedido.representanteId as IdRep, 
                    COUNT(Kit.id) as EmAberto 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    WHERE Kit.statusKit = 2 
                    AND Kit.tipo = 0 
                    ${sectorId.length > 0 ? `AND Pedido.gerenteSetorId = '${sectorId}' ` : ""}
                    ${regionalId.length > 0 ? `AND Pedido.gerenteRegionalId = '${regionalId}' ` : ""}
                    GROUP BY Pedido.representanteId`
                },
                {
                    "coderesult": "EmAbertoAcerto",
                    "query": `SELECT Pedido.representanteId as IdRep, 
                    COUNT(Kit.id) as EmAberto 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    WHERE Kit.statusKit = 2 
                    AND Kit.tipo = 1 
                    ${sectorId.length > 0 ? `AND Pedido.gerenteSetorId = '${sectorId}' ` : ""}
                    ${regionalId.length > 0 ? `AND Pedido.gerenteRegionalId = '${regionalId}' ` : ""}
                    GROUP BY Pedido.representanteId`
                },
                {
                    "coderesult": "Cadastrados",
                    "query": `SELECT Pedido.representanteId as IdRep, 
                    COUNT(Kit.id) as Cadastrados 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    WHERE Kit.statusKit = 3 
                    AND Kit.tipo = 0 
                    AND Kit.dataEntrega >= '${initialDate}' 
                    AND Kit.dataEntrega < '${endDate}' 
                    ${sectorId.length > 0 ? `AND Pedido.gerenteSetorId = '${sectorId}' ` : ""}
                    ${regionalId.length > 0 ? `AND Pedido.gerenteRegionalId = '${regionalId}' ` : ""}
                    GROUP BY Pedido.representanteId`
                },
                {
                    "coderesult": "Faturamento",
                    "query": `SELECT Conference.representanteId as IdRep, 
                    COUNT(Conference.kitId) as Conferencias, 
                    (SUM(Conference.valorRecebido) - SUM(Conference.valorReceber)) as Debitos, 
                    (SUM(Conference.valorRecebido) - SUM(Conference.comissaoRepresentante)) as Faturamento 
                    FROM Conference 
                    INNER JOIN Representante 
                    ON Representante.id = Conference.representanteId 
                    INNER JOIN GerenteSetor 
                    ON GerenteSetor.id = Representante.gerenteSetorId 
                    INNER JOIN GerenteRegional 
                    ON GerenteRegional.id = GerenteSetor.gerenteRegionalId 
                    WHERE Conference.conferenceType = 0 
                    AND Conference.data >= '${initialDate}' 
                    AND Conference.data < '${endDate}' 
                    ${regionalId.length > 0 ? `AND GerenteRegional.id = '${regionalId}' ` : ""}
                    ${sectorId.length > 0 ? `AND GerenteSetor.id = '${sectorId}' ` : ""} 
                    GROUP BY Conference.representanteId`
                }
            ]
        };

        const response = await api.post<IAgentResponse[]>("reports", body);        
        const representanteResponse = this.GetFromCodeResult(response.data, "DadosRp");        
        const emAbertoResponse = this.GetFromCodeResult(response.data, "EmAberto");        
        const emAbertoAcertoResponse = this.GetFromCodeResult(response.data, "EmAbertoAcerto");
        const cadastrosResponse = this.GetFromCodeResult(response.data, "Cadastrados");        
        const faturamentoResponse = this.GetFromCodeResult(response.data, "Faturamento");        

        return representanteResponse.map(dadosRepresentante => {
            const dadosFaturamento = faturamentoResponse.find(faturamentoDado => faturamentoDado.IdRep === dadosRepresentante.IdRep);
            return {
                representante: dadosRepresentante.Nome,
                dataCad: dadosRepresentante.Data,
                emAberto: emAbertoResponse.find(emAbertoDado => emAbertoDado.IdRep === dadosRepresentante.IdRep)?.EmAberto || 0,
                emAbertoAcerto: emAbertoAcertoResponse.find(emAbertoAcertoDado => emAbertoAcertoDado.IdRep === dadosRepresentante.IdRep)?.EmAberto || 0,
                cadastros: cadastrosResponse.find(cadastrosDado => cadastrosDado.IdRep === dadosRepresentante.IdRep)?.Cadastrados || 0,                
                faturamento: dadosFaturamento?.Faturamento || 0,
                debitos: dadosFaturamento?.Debitos || 0,
                conferencias: dadosFaturamento?.Conferencias || 0
            }
        })
    }

    GetFromCodeResult(data: IAgentResponse[], codeResult: string) {

        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const agentHistoryRepository = new AgentHistoryRepository();
export default agentHistoryRepository;